import { ExportActionTypes, ExportCsvState } from "./types"
import { WS_MESSAGE_RECEIVED } from "../websockets/types"

const initialState: ExportCsvState = {
    computerEaseFormat: null,
    submitting: false,
    fetchExportSubmissionErrors: "",
    fetchingFormats: false,
    formats: [],
    selectedFormat: null,
    exportSubmissions: [],
    exportFormats: [],
    next: "",
}

export default function (state = initialState, action: ExportActionTypes): ExportCsvState {
    switch (action.type) {
        case "EXPORT_ACTION_STARTED":
            return Object.assign({}, state, { submitting: true })
        case "EXPORT_ACTION_COMPLETED":
            return Object.assign({}, state, { submitting: false })
        case "FETCHING_EXPORT_FORMATS":
            return Object.assign({}, state, { fetchingFormats: true })
        case "UPDATE_EXPORT_FORMATS":
            return Object.assign({}, state, {
                formats: action.data,
                fetchingFormats: false,
                selectedFormat: action.data.length > 0 ? action.data[0] : null,
            })
        case "UPDATE_COMPUTEREASE_EXPORT_FORMAT":
            return Object.assign({}, state, { computerEaseFormat: action.data })
        case "UPDATE_EXPORT_FORMAT_SELECTED":
            return Object.assign({}, state, { selectedFormat: action.data })
        case "EXPORT_STARTED":
            return { ...state, exportSubmissions: [action.data, ...state.exportSubmissions] }
        case "SET_EXPORTS":
            return { ...state, exportSubmissions: action.data, fetchExportSubmissionErrors: "", next: action.next }
        case "FETCH_EXPORT_SUBMISSIONS_FAILED":
            return { ...state, fetchExportSubmissionErrors: action.error }
        case "SET_EXPORT_FORMATS":
            return { ...state, exportFormats: action.data }
        case "UPSERT_EXPORT_FORMAT":
            if (state.exportFormats.find(format => format.id === action.data.id)) {
                return {
                    ...state,
                    exportFormats: state.exportFormats.map(format => {
                        if (format.id === action.data.id) {
                            return { ...format, ...action.data }
                        }
                        return format
                    }),
                }
            } else {
                return {
                    ...state,
                    exportFormats: [...state.exportFormats, action.data],
                }
            }

        case WS_MESSAGE_RECEIVED:
            // Parse out a particular type of message and update the exports in the state
            // with the new payload information
            if (!("event" in action) || action.event.data instanceof Blob) return state
            const data = JSON.parse(action.event.data)
            if (!data.export_run_id) return state

            return {
                ...state,
                exportSubmissions: state.exportSubmissions.map(submission => {
                    if (submission.id === data.export_run_id) {
                        return { ...submission, ...data.export_info }
                    }
                    return submission
                }),
            }
        default:
            return state
    }
}
